import { Component } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatError } from '@angular/material/form-field';
import { Router, RouterLink } from '@angular/router';
import { MatButtonLoading } from '@ng-matero/extensions/button';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

import { AuthService } from '@core';
import { StringUtils } from '@shared/utils/stringUtils';

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    styleUrls: ['./forgot-password.component.scss'],
    imports: [ReactiveFormsModule, MatError, MatButton, MatButtonLoading, RouterLink, TranslatePipe]
})
export class ForgotPasswordComponent {
  protected readonly authLogo = StringUtils.brandResourceWithFallback('sidebarLogo');

  public forgotPasswordForm = this.fb.nonNullable.group({
    email: ['', [Validators.required, Validators.email]],
  });
  public isSubmitting = false;
  public emailSent = false;

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private auth: AuthService,
    private translate: TranslateService
  ) {}

  public get email() {
    return this.forgotPasswordForm.get('email')!;
  }

  public getCheckYourEmailDescription(): string {
    const results = this.translate.instant('check_your_email_description', {
      email: this.email.value,
    });
    return results;
  }

  public sendRemind(): void {
    this.emailSent = true;
  }
}
